"use strict";

const VERSION = require('../package.json').version;

let GLOBAL = {};

if (typeof window === 'object') {
  GLOBAL = window;
} else if (typeof global === 'object') {
  GLOBAL = global;
}

if (GLOBAL.leveregePlugin) {
  const version = GLOBAL.leveregePlugin.version; // eslint-disable-next-line no-console

  console.log(`Version ${VERSION} of @leverege/plugins library found another installed verison: ${version}`);
  module.exports = GLOBAL.leveregePlugin.library;
} else {
  const Isa = require('./Isa');

  const Plugins = require('./Plugins');

  const Context = require('./Context');

  const Match = require('./Match');

  const Layout = require('./Layout');

  const Config = require('./Config');

  const Util = require('./Util');

  const View = require('./View');

  const PluginCreator = require('./PluginCreator');

  const Factory = require('@leverege/factory');

  exports.Plugins = new Plugins(); // create a singleton

  exports.Isa = new Isa(); // create a singleton

  exports.Factory = Factory;
  exports.Context = Context;
  exports.PluginCreator = PluginCreator;
  exports.Match = Match;
  exports.Layout = Layout;
  exports.View = View;
  exports.Config = Config;
  exports.Util = Util;
  exports.resolve = Util.resolve;
  GLOBAL.leveregePlugin = {
    version: VERSION,
    library: exports
  };
}